/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TextField from "@mui/material/TextField";
import TabComponent from "components/TabComponent";
import Button from "../../components/ButtonUse.jsx";
import axios from "axios";
import useSWR from "swr";
import config from "../../utils/awsCnfig";
import Select from "react-select";
import { baseURL, baseuRL } from "utils/api";
import LoaderComponent from "components/Loader";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { IoIosRemoveCircleOutline } from "react-icons/io";
import tempImage from "../../assets/images/clothes.avif";
import ModalComponent from "components/MDTypography/ModalComponent";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import React from "react";
import { uploadFile } from "react-s3";
import "./tables.css";
import placeholder from "../../assets/images/placeholder.png";
window.Buffer = window.Buffer || require("buffer").Buffer;
// import tempImage from "../../assets/images/clothes.jpg";

// import Button from "../../components/ButtonUse.jsx";
// Data

// Dashboard components
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
function AddProduct() {
  const [colorOptions, setColotherOptions] = useState([
    {
      value: "",
      quantity: "",
      subtractStock: "",
      sellingprice: "",
      price: "",
      priceType: "",
      image: "",
      preview: "",
      points: "",
      pointType: "",

      weight: "",
      weightType: "",
    },
  ]);
  console.log(colorOptions);
  const [sizeOptions, setSizeOptions] = useState([
    {
      value: "",
      quantity: "",
      subtractStock: "",
      selectedValue: "",
      price: "",
      image: "",
      preview: "",
      priceType: "",
      sellingprice: "",
      points: "",
      pointType: "",
      image: "",
      preview: "",
      weight: "",
      weightType: "",
    },
  ]);
  const [atttribute3, setAttribute3] = useState([
    {
      value: "",
      quantity: "",
      subtractStock: "",
      sellingprice: "",
      price: "",
      priceType: "",
      image: "",
      preview: "",
      points: "",
      pointType: "",
      weight: "",
      weightType: "",
    },
  ]);

  //   fetch category names for select option-:

  const fetchData = async (url) => {
    try {
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  // upload to aws for color options (attribute 1);
  const uploadFiletoS3ColorOptions = async () => {
    try {
      const colorState = [...colorOptions];

      for (let i = 0; i < colorState.length; i++) {
        const file = colorState[i].image;
        console.log(file);
        if (file) {
          const { location } = await uploadFile(file, config);
          colorState[i].image = location;

          // Exclude the 'preview' property from the state
          delete colorState[i].preview;
        }
      }

      setColotherOptions(colorState);
    } catch (error) {
      console.log(error);
    }
  };
  //  upload to asw s3 for size options(att2)
  const uploadFiletoS3SizeOptions = async () => {
    try {
      const sizeState = [...sizeOptions];

      for (let i = 0; i < sizeState.length; i++) {
        const file = sizeState[i].image;
        console.log(file);
        if (file) {
          const { location } = await uploadFile(file, config);
          sizeState[i].image = location;

          // Exclude the 'preview' property from the state
          delete sizeState[i].preview;
        }
      }

      setSizeOptions(sizeState);
    } catch (error) {
      console.log(error);
    }
  };

  // upload to s3 for attribute 3

  const uploadFiletoS3Attr3 = async () => {
    try {
      const sizeState = [...atttribute3];

      for (let i = 0; i < sizeState.length; i++) {
        const file = sizeState[i].image;
        console.log(file);
        if (file) {
          const { location } = await uploadFile(file, config);
          sizeState[i].image = location;

          // Exclude the 'preview' property from the state
          delete sizeState[i].preview;
        }
      }

      setAttribute3(sizeState);
    } catch (error) {
      console.log(error);
    }
  };
  const [categoryImages, setCategoryImages] = useState([
    {
      image: "",
      preview: "",
    },
  ]);

  // upload category images to s3
  const uploadFiletoS3CategoryImg = async () => {
    try {
      const sizeState = [...categoryImages];

      for (let i = 0; i < sizeState.length; i++) {
        const file = sizeState[i].image;
        console.log(file);
        if (file) {
          const { location } = await uploadFile(file, config);
          sizeState[i].image = location;

          // Exclude the 'preview' property from the state
          delete sizeState[i].preview;
        }
      }

      setCategoryImages(sizeState);
    } catch (error) {
      console.log(error);
    }
  };

  const { data, error } = useSWR(`${baseURL}/admin/fetch/categorynames`, fetchData);
  // declare options for react-select
  const options = data;
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const handleClose = () => setOpenDialog(false);
  const [category, setCategory] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [formLoading, setFormLoading] = useState(false);
  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setSelectedFile(file);
      const imageUrl = URL.createObjectURL(file);
      setPreviewUrl(imageUrl);
    }
  };
  const [attributes, setAttrributes] = useState([
    {
      text: "",
    },
  ]);

  const [productImages, setProductImages] = useState([
    {
      imageUrl: "",
      sortOrder: "",
    },
  ]);

  const [categoryVid, setCategoryVid] = useState("");

  const [formState, setFormState] = useState({
    ruSubject: "",
    discriptionPath: "",
    productId: "",
    categoryName: "",
    // ruSubject: "",
    sizePath: "",
    ocrSize: "",
    sumCarriage: "",
    salePrice: "",
    price: "",
    quantity: "",
    minQuantity: "",
    subtractStock: "",
    taxClass: "",
    size1: "",
    size2: "",
    size3: "",
    size4: "",
    size5: "",
    size6: "",
    size7: "",
    size8: "",
    skuId: "",
    specId: "",
    mOQ: "",
    unit: "",
    sendGoodAddressText: "",
    suttleWeight: "",
    amountOnSale: "",
    requiresShipping: "",
    sortOrder: "",

    status: "",
    length: "",
    width: "",
    height: "",
    lengthClass: "",
    weightClass: "",
    qtyInStock: "",
    supplierUserId: "",
    rAttribute: "",
  });

  const tabProps = [
    {
      title: "General",
      content: (
        <GeneralDetailsForm
          options={options}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          data={formState}
          setFunc={setFormState}
        />
      ),
      id: 1,
    },
    {
      title: "Data",
      content: (
        <DataForm
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          data={formState}
          setFunc={setFormState}
          preview={previewUrl}
          selectedFile={selectedFile}
          handleChange={handleFileChange}
          handleClose={handleClose}
        />
      ),
      id: 2,
    },

    {
      title: "RUAttributes",
      content: <AttributesForm data={formState} setFunc={setFormState} />,
      id: 4,
    },
    {
      title: "Options",
      content: (
        <OptionsForm
          colorOptions={colorOptions}
          sizeOptions={sizeOptions}
          setColotherOptions={setColotherOptions}
          setSizeOptions={setSizeOptions}
          atttribute3={atttribute3}
          setAttribute3={setAttribute3}
        />
      ),
      id: 6,
    },
    {
      title: "Images",
      content: (
        <ImageForm
          categoryImages={categoryImages}
          setCategoryImages={setCategoryImages}
          categoryVid={categoryVid}
          setCategoryVid={setCategoryVid}
        />
      ),
      id: 7,
    },
    {
      title: "SEO",
      content: <SeoForm data={formState} setFunc={setFormState} />,
      id: 8,
    },
  ];

  const createdDate = new Date();
  const createdTime = createdDate.toLocaleTimeString([], { hour12: true });

  console.log(formState.categoryName);
  const categoryId = formState.categoryName?.value;
  // const handleUploadProduct = async (e) => {
  //   e.preventDefault();
  //   setFormLoading(true);
  //   await uploadFiletoS3ColorOptions();
  //   await uploadFiletoS3SizeOptions();
  //   await uploadFiletoS3Attr3();
  //   await uploadFiletoS3CategoryImg();
  //   const formData = new FormData();
  //   formData.append("ruSubject", formState.ruSubject);
  //   formData.append("categoryName", formState.categoryName?.value);
  //   formData.append("categoryId", categoryId);
  //   formData.append("discriptionPath", formState.discriptionPath);
  //   formData.append("productId", formState.productId);
  //   formData.append("ruSubject", formState.ruSubject);
  //   formData.append("sizePath", formState.sizePath);
  //   formData.append("ocrSize", formState.ocrSize);
  //   formData.append("sumCarriage", formState.sumCarriage);
  //   formData.append("price", formState.price);
  //   formData.append("quantity", formState.quantity);
  //   formData.append("subtractStock", formState.subtractStock);
  //   formData.append("taxClass", formState.taxClass);
  //   formData.append("mOQ", formState.mOQ);
  //   formData.append("unit", formState.unit);
  //   formData.append("sendGoodAddressText", formState.sendGoodAddressText);
  //   formData.append("amountOnSale", formState.amountOnSale);
  //   formData.append("requiresShipping", formState.requiresShipping);
  //   formData.append("sortOrder", formState.sortOrder);
  //   formData.append("status", formState.status);
  //   formData.append("length", formState.length);
  //   formData.append("width", formState.width);
  //   formData.append("heigth", formState.height);
  //   formData.append("skuId", formState.skuId);
  //   formData.append("specId", formState.specId);
  //   formData.append("qtyInStock", formState.qtyInStock);
  //   formData.append("salePrice", formState.salePrice);
  //   formData.append("attr1", JSON.stringify(colorOptions));
  //   formData.append("attr2", JSON.stringify(sizeOptions));
  //   formData.append("attr3", JSON.stringify(atttribute3));
  //   formData.append("categoryImages", JSON.stringify(categoryImages));
  //   formData.append("attributeArray", JSON.stringify([formState.rAttribute]));
  //   formData.append("createdDate", createdDate.toISOString().split("T")[0]);
  //   formData.append("createdTime", createdTime);
  //   formData.append("storeName", formState.supplierUserId);

  //   // try {

  //   //   const res = await axios.post(`${baseuRL}/admin/products/createProducts`, formData);
  //   //   setFormLoading(false);
  //   //   navigate("/products-list");
  //   // } catch (error) {
  //   //   console.log(error);
  //   //   setFormLoading(false);
  //   // }
  //   try {
  //     const response = await fetch(`${baseURL}/products/createProducts`, {
  //       method: "POST",
  //       body: formData,
  //     });

  //     if (response.ok) {
  //       setFormLoading(false);
  //       navigate("/products-list");
  //     } else {
  //       // Handle error response
  //       const errorText = await response.text();
  //       console.error("Error:", errorText);
  //       setFormLoading(false);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     setFormLoading(false);
  //   }
  // };

  const handleUploadProduct = async (e) => {
    e.preventDefault();
    setFormLoading(true);

    // Assuming these functions are defined and working properly
    await uploadFiletoS3ColorOptions();
    await uploadFiletoS3SizeOptions();
    await uploadFiletoS3Attr3();
    await uploadFiletoS3CategoryImg();

    const formData = new FormData();
    formData.append("ruSubject", formState.ruSubject);
    formData.append("categoryName", formState.categoryName);
    // formData.append("categoryId", categoryId);
    // formData.append("discriptionPath", formState.discriptionPath);
    // formData.append("productId", formState.productId);
    // Append other form fields as needed

    try {
      const response = await fetch(
        "https://jamunona-api.onrender.com/api/products/createProducts",
        {
          method: "POST",
          body: formData,
        }
      );

      if (response.ok) {
        setFormLoading(false);
        navigate("/products-list");
      } else {
        const errorText = await response.text();
        console.error("Error:", errorText);
        setFormLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setFormLoading(false);
    }
  };

  // --------------------------ADD PRODUCT------------------------//
  // const [categoryName, setCategoryName] = useState("");
  // const [ruSubject, setRuSubject] = useState("");

  // const handleProduct = async (event) => {
  //   event.preventDefault();
  //   try {
  //     const details = { categoryName, ruSubject };
  //     const response = await fetch("https://jumunona.onrender.com/admin/products/createProducts", {
  //       method: "POST",
  //       body: JSON.stringify(details),
  //       headers: {
  //         "Content-Type": "application/json",
  //       },
  //     });

  //     if (response.ok) {
  //       // Handle success response if needed
  //     } else {
  //       const error = await response.text();
  //       // Handle error response if needed
  //     }

  //     console.log(ruSubject, "aaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
  //     setRuSubject("");
  //     setCategoryName("");
  //     window.location.reload();
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  return (
    <DashboardLayout>
      {/* {loading && <LoaderComponent open={true} />} */}
      {formLoading && <LoaderComponent open={true} />}
      <DashboardNavbar />
      {/* <input type="file" onChange={(e) => setAwsImg(e.target.files[0])} />
      <button onClick={() => uploadFile(awsImg)}>Upload test image</button> */}
      <form
        onSubmit={handleUploadProduct}
        style={{
          background: "white",
          padding: "10px",
          borderRadius: "10px",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          overflow: "scroll",
        }}
      >
        <div style={{ display: "flex", gap: "20px", justifyContent: "end" }}>
          <Button title={"Submit"} type={"submit"} background={"green"} />
          <Button
            cliclHandler={() => {
              navigate(-1);
            }}
            title={"Cancel"}
            background={"red"}
            type={"button"}
          />
        </div>

        <TabComponent tabContent={tabProps} />
      </form>

      <Footer />
    </DashboardLayout>
  );
}

export default AddProduct;

function GeneralDetailsForm({ data, options, setFunc, selectedCategory, setSelectedCategory }) {
  useEffect(() => {
    setSelectedCategory(selectedCategory);
    setFunc({ ...data, categoryName: selectedCategory });
  }, [selectedCategory]);
  console.log(selectedCategory);
  // console.log(options);

  return (
    <>
      <div style={{ padding: "5px" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw", marginTop: "5vh" }}
            label="Product name"
            placeholder="Exmples"
            value={data?.ruSubject}
            onChange={(e) => setFunc({ ...data, ruSubject: e.target.value })}
            variant="outlined"
            required
          />

          {/* <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Product tags"
            placeholder="Exmples"
            // value={data?.categoryName}
            // onChange={(e) => setFunc({ ...data, categoryName: e.target.value })}
            variant="outlined"
          /> */}
          <div className="flex flex-col gap-3 pb-20">
            <span className="text-sm">Category Name</span>
            <Select
              options={options}
              defaultValue={selectedCategory}
              onChange={setSelectedCategory}
            />
          </div>
        </div>
      </div>
    </>
  );
}

function DataForm({
  data,
  setFunc,
  preview,
  selectedFile,
  handleChange,
  openDialog,
  setOpenDialog,
  handleClose,
}) {
  return (
    <>
      <div style={{ padding: "5px", paddingBottom: "10vh" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="RU subject"
            variant="outlined"
            value={data?.ruSubject}
            onChange={(e) => setFunc({ ...data, ruSubject: e.target.value })}
          />

          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Sum Carriage"
            variant="outlined"
            value={data?.sumCarriage}
            onChange={(e) => setFunc({ ...data, sumCarriage: e.target.value })}
          />

          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Price"
            variant="outlined"
            value={data?.price}
            type="text"
            onChange={(e) => {
              const inputValue = e.target.value.trim();

              // Check if the input is a valid non-negative number
              if (
                inputValue === "" ||
                (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
              ) {
                setFunc({ ...data, price: inputValue });
              }
            }}
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Sale Price"
            variant="outlined"
            type="text"
            value={data?.salePrice}
            onChange={(e) => {
              const inputValue = e.target.value.trim();

              // Check if the input is a valid non-negative number
              if (
                inputValue === "" ||
                (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
              ) {
                setFunc({ ...data, salePrice: inputValue });
              }
            }}
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Tax Class"
            variant="outlined"
            value={data?.taxClass}
            onChange={(e) => setFunc({ ...data, taxClass: e.target.value })}
          />

          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Quantity in Stock"
            variant="outlined"
            type="text"
            value={data.quantity}
            onChange={(e) => {
              const inputValue = e.target.value.trim();

              // Check if the input is a valid non-negative number
              if (
                inputValue === "" ||
                (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
              ) {
                setFunc({ ...data, quantity: inputValue });
              }
            }}
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Minimum Order Quantity"
            variant="outlined"
            type="text"
            value={data?.mOQ}
            onChange={(e) => {
              const inputValue = e.target.value.trim();

              // Check if the input is a valid non-negative number
              if (
                inputValue === "" ||
                (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
              ) {
                setFunc({ ...data, mOQ: inputValue });
              }
            }}
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Store Name"
            variant="outlined"
            value={data?.supplierUserId}
            onChange={(e) => setFunc({ ...data, supplierUserId: e.target.value })}
          />

          <div className="flex flex-col">
            <span>Subtract Stock</span>
            <select className="h-[7vh] w-[20vw] p-2" name="value" id="">
              <option>Select</option>
              <option>Yes</option>
              <option>No</option>
            </select>
          </div>

          <div className="flex flex-col">
            <span>Unit</span>
            <select
              value={data.unit}
              onChange={(e) => setFunc({ ...data, unit: e.target.value })}
              className="h-[7vh] w-[20vw] p-2"
              name="value"
              id=""
            >
              <option>Select</option>
              <option>Single</option>
              <option>Pair</option>
              <option>Set</option>
            </select>
          </div>
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Send Goods address text"
            variant="outlined"
            value={data?.sendGoodAddressText}
            onChange={(e) => setFunc({ ...data, sendGoodAddressText: e.target.value })}
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Suttle Weight"
            variant="outlined"
            value={data?.suttleWeight}
            onChange={(e) => setFunc({ ...data, suttleWeight: e.target.value })}
          />
          {/* <div className="mt-4 flex flex-col gap-3">
            <span>Requires Shipping</span>
            <div className="flex gap-2">
              <div className="flex gap-2">
                <label htmlFor="">Train</label>
                <input type="radio" />
              </div>
              <div className="flex gap-2">
                <label htmlFor="">Air</label>
                <input type="radio" />
              </div>
            </div>
          </div> */}
          {/* <div className="flex flex-col gap-3">
            <span>Date Available</span>
            <input type="date" className="w-[30vw] h-[4vh]" />
          </div> */}
          <div className="flex flex-col gap-3">
            <span>Dimensions(L x W x H)</span>
            <div className="flex gap-3">
              <input
                value={data.length}
                onChange={(e) => {
                  const inputValue = e.target.value.trim();

                  // Check if the input is a valid non-negative number
                  if (
                    inputValue === "" ||
                    (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                  ) {
                    setFunc({ ...data, length: inputValue });
                  }
                }}
                className="w-[20vw] h-[6vh] p-2"
                type="text"
                placeholder="Length"
              />
              <input
                value={data.width}
                onChange={(e) => {
                  const inputValue = e.target.value.trim();

                  // Check if the input is a valid non-negative number
                  if (
                    inputValue === "" ||
                    (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                  ) {
                    setFunc({ ...data, width: inputValue });
                  }
                }}
                className="w-[20vw] h-[6vh] p-2"
                type="text"
                placeholder="Width"
              />
              <input
                value={data.height}
                onChange={(e) => {
                  const inputValue = e.target.value.trim();

                  // Check if the input is a valid non-negative number
                  if (
                    inputValue === "" ||
                    (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                  ) {
                    setFunc({ ...data, height: inputValue });
                  }
                }}
                className="w-[20vw] h-[6vh] p-2"
                type="text"
                placeholder="Height"
              />
            </div>
          </div>
          <div className="flex flex-col">
            <span>Length Class</span>
            <select
              value={data.lengthClass}
              onChange={(e) => setFunc({ ...data, lengthClass: e.target.value })}
              className="h-[7vh] w-[20vw] p-2"
              name="value"
              id=""
            >
              <option>Select</option>
              <option>cm</option>
              <option>m</option>
            </select>
          </div>
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw", marginTop: "5vh" }}
            label="Weight"
            variant="outlined"
            value={data?.weight}
            type="text"
            onChange={(e) => {
              const inputValue = e.target.value.trim();

              // Check if the input is a valid non-negative number
              if (
                inputValue === "" ||
                (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
              ) {
                setFunc({ ...data, weight: inputValue });
              }
            }}
          />
          <div className="flex flex-col">
            <span>Weight Class</span>
            <select
              value={data.weightClass}
              onChange={(e) => setFunc({ ...data, weightClass: e.target.value })}
              className="h-[7vh] w-[20vw] p-2"
              name="value"
              id=""
            >
              <option>Select</option>
              <option>grams</option>
              <option>kgs</option>
            </select>
          </div>
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Sort Order"
            type="text"
            variant="outlined"
            value={data?.sortOrder}
            onChange={(e) => {
              const inputValue = e.target.value.trim();

              // Check if the input is a valid non-negative number
              if (
                inputValue === "" ||
                (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
              ) {
                setFunc({ ...data, sortOrder: inputValue });
              }
            }}
          />
          <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
            <span>Status</span>
            <select
              value={data.status}
              onChange={(e) => setFunc({ ...data, status: e.target.value })}
              style={{ width: "60vw", height: "5vh" }}
              name=""
              id=""
            >
              <option>Select</option>
              <option>Enabled</option>
              <option>Disabled</option>
            </select>
          </div>
        </div>
      </div>
    </>
  );
}

// component link form for handeling the product form

function LinksForm({ data, setFunc }) {
  return (
    <>
      <div style={{ padding: "5px" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Seller"
            placeholder="Exmples"
            // value={data?.categoryName}
            // onChange={(e) => setFunc({ ...data, categoryName: e.target.value })}
            variant="outlined"
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Manufacturer"
            placeholder="Exmples"
            // value={data?.categoryName}
            // onChange={(e) => setFunc({ ...data, categoryName: e.target.value })}
            variant="outlined"
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Categories (can be comma separated)"
            placeholder="Men,women,kids"
            // value={data?.categoryName}
            // onChange={(e) => setFunc({ ...data, categoryName: e.target.value })}
            variant="outlined"
          />
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Filters (can be comma separated)"
            placeholder="Men,women,kids"
            // value={data?.categoryName}
            // onChange={(e) => setFunc({ ...data, categoryName: e.target.value })}
            variant="outlined"
          />
          <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
            <span>Stores</span>
            <input
              // checked={data?.pinned}
              // onChange={(e) => setFunc({ ...data, pinned: !data.pinned })}
              style={{ cursor: "pointer" }}
              type="checkbox"
            />
          </div>
        </div>
      </div>
    </>
  );
}

// component to handle attributes form for product

function AttributesForm({ data, setFunc }) {
  const str = data.rAttribute.split("<br>");
  console.log(str);

  return (
    <>
      <div style={{ padding: "5px" }}>
        <div className="flex flex-col gap-2">
          <span className="text-sm">Add RU Attributes</span>
          <textarea
            value={data.rAttribute}
            onChange={(e) => setFunc({ ...data, rAttribute: e.target.value })}
            placeholder="Enter"
            className="w-[50vw] p-2"
            name=""
            id=""
            cols="30"
            rows="10"
          ></textarea>
        </div>
      </div>
    </>
  );
}

// component to handle options form for product

function OptionsForm({
  colorOptions,
  setColotherOptions,
  sizeOptions,
  setSizeOptions,
  atttribute3,
  setAttribute3,
}) {
  const [selectedOption, setSelectedOption] = useState("att1");

  const handleSelectOption = (opt) => {
    setSelectedOption(opt);
  };
  const handleAddColorAttribute = () => {
    const newData = [...colorOptions];
    newData.push({
      value: "",
      image: "",
      preview: "",
      subtractStock: "",

      price: "",

      points: "",

      weight: "",
    });
    setColotherOptions(newData);
  };

  const removeColorAttribute = (idx) => {
    const newData = [...colorOptions];
    newData.splice(idx, 1);
    setColotherOptions(newData);
  };

  const handleAddSizeAttribute = () => {
    const newData = [...sizeOptions];
    newData.push({
      value: "",
      selectedValue: "",
      subtractStock: "",

      price: "",

      points: "",

      weight: "",
    });
    setSizeOptions(newData);
  };

  const handleAddAtt3 = () => {
    const newData = [...atttribute3];
    newData.push({
      value: "",
      selectedValue: "",
      subtractStock: "",

      price: "",

      points: "",

      weight: "",
    });
    setAttribute3(newData);
  };

  const handleRemoveSizeAttribute = (idx) => {
    const newData = [...sizeOptions];
    newData.splice(idx, 1);
    setSizeOptions(newData);
  };

  const handleRemoveAtt3 = (idx) => {
    const newData = [...atttribute3];
    newData.splice(idx, 1);
    setAttribute3(newData);
  };

  // on change handler of color and size options-:

  const handlChangeColor = (index, name, value) => {
    const newData = [...colorOptions];
    newData[index][name] = value;
    setColotherOptions(newData);
  };
  const handleChangeSize = (index, name, value) => {
    const newData = [...sizeOptions];
    newData[index][name] = value;
    setSizeOptions(newData);
  };

  const handleChangeAtt3 = (index, name, value) => {
    const newData = [...atttribute3];
    newData[index][name] = value;
    setAttribute3(newData);
  };

  const attributesValuesFromFirst = colorOptions.map((c) => c.value);

  const attribute3Values = sizeOptions.map((s) => {
    return {
      value: `${s.selectedValue}/${s.value}`,
    };
  });

  // image change handler for coloroptions-:

  const handleImageChangeColor = (index, event) => {
    const updatedOptions = [...colorOptions];
    handleImagePreviewColor(index, event);
    setColotherOptions(updatedOptions);
  };

  // handle image preview for coloroptions-:

  function handleImagePreviewColor(index, event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const updatedOptions = [...colorOptions];
        updatedOptions[index].image = file;
        updatedOptions[index].preview = reader.result;
        setColotherOptions(updatedOptions);
      };

      reader.readAsDataURL(file);
    }
  }

  // image change handler for color options-:

  const handleImageChangeSizes = (index, event) => {
    const updatedOptions = [...sizeOptions];
    handleImagePreviewSize(index, event);
    setSizeOptions(updatedOptions);
  };

  function handleImagePreviewSize(index, event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const updatedOptions = [...sizeOptions];
        updatedOptions[index].image = file;
        updatedOptions[index].preview = reader.result;
        setSizeOptions(updatedOptions);
      };

      reader.readAsDataURL(file);
    }
  }

  const handleImageChangeAtt3 = (index, event) => {
    const updatedOptions = [...atttribute3];
    handleImagePreviewAtt3(index, event);
    setAttribute3(updatedOptions);
  };

  function handleImagePreviewAtt3(index, event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const updatedOptions = [...atttribute3];
        updatedOptions[index].image = file;
        updatedOptions[index].preview = reader.result;
        setAttribute3(updatedOptions);
      };

      reader.readAsDataURL(file);
    }
  }

  return (
    <>
      <div style={{ padding: "5px" }}>
        <div>
          <button
            type="button"
            style={{ border: "0.5px solid black" }}
            onClick={() => handleSelectOption("att1")}
            className={`rounded-2xl cursor-pointer    ${
              selectedOption === "att1" ? "bg-blue-700 text-white" : "bg-gray-300 text-black"
            } p-3 w-[7vw]`}
          >
            Attr1
          </button>
          <button
            onClick={() => handleSelectOption("att2")}
            type="button"
            style={{ border: "0.5px solid black" }}
            className={`rounded-2xl cursor-pointer    ${
              selectedOption === "att2" ? "bg-blue-700 text-white" : "bg-gray-300 text-black"
            } p-3 w-[7vw]`}
          >
            Attr2
          </button>
          <button
            onClick={() => handleSelectOption("att3")}
            type="button"
            style={{ border: "0.5px solid black" }}
            className={`rounded-2xl cursor-pointer    ${
              selectedOption === "att3" ? "bg-blue-700 text-white" : "bg-gray-300 text-black"
            } p-3 w-[7vw]`}
          >
            Attr3
          </button>
        </div>
        {/* <div className="flex gap-2 mt-4">
          <span
            onClick={() => handleSelectOption("att1")}
            className={` ${
              selectedOption === "att1" ? "bg-gray-100 text-black" : "bg-white"
            } cursor-pointer pt-2 rounded-xl text-center text-sm  w-[7vw]`}
          >
            Attr 1
          </span>
          <span
            onClick={() => handleSelectOption("att2")}
            className={` ${
              selectedOption === "att2" ? "bg-blue-500 text-white" : "bg-white"
            } cursor-pointer text-center  p-3 w-[15vw] rounded-md`}
          >
            Attr 2
          </span>
          <span
            onClick={() => handleSelectOption("att3")}
            className={` ${
              selectedOption === "att3" ? "bg-blue-500 text-white" : "bg-white"
            } cursor-pointer text-center  p-3 w-[15vw] rounded-md`}
          >
            Attr 3
          </span>
        </div> */}
        <div className="mt-4">
          {selectedOption === "att1" && (
            <table>
              <thead>
                <tr>
                  <th className="font-semibold text-md">Name</th>
                  <th>Choose Image</th>
                  <th>Quantity</th>
                  <th>Subtract Stock</th>
                  <th>Price</th>
                  <th>Selling Price</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {colorOptions.map((c, idx) => {
                  return (
                    <tr key={idx}>
                      <td>
                        <input
                          name="value"
                          onChange={(e) => handlChangeColor(idx, e.target.name, e.target.value)}
                          type="text"
                          value={c.value}
                          placeholder="Enter Attribute Name"
                          className="p-2 pl-2 w-[15vw]"
                        />
                      </td>
                      <td>
                        <div>
                          <div className="flex flex-col ml-4  gap-3  items-center">
                            <label className="" htmlFor={`profile_pic_${idx}`}>
                              <img
                                className="rounded-md"
                                style={{
                                  width: "150px",
                                  height: "40px",
                                  objectFit: "contain",
                                  cursor: "pointer",
                                  borderRadius: "5px",
                                }}
                                src={c?.preview ? c.preview : placeholder}
                                alt="temp_img"
                              />
                            </label>
                          </div>

                          <input
                            name="image"
                            id={`profile_pic_${idx}`}
                            style={{ display: "none" }}
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleImageChangeColor(idx, e)}
                          />
                        </div>
                      </td>
                      <td>
                        <input
                          placeholder="Enter Quantity"
                          value={c.quantity}
                          onChange={(e) => {
                            const inputValue = e.target.value.trim();
                            if (
                              inputValue === "" ||
                              (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            ) {
                              handlChangeColor(idx, e.target.name, e.target.value);
                            }
                          }}
                          type="text"
                          name="quantity"
                          className="w-[10vw] p-2 h-[6vh]"
                        />
                      </td>
                      <td>
                        <select
                          value={c.subtractStock}
                          onChange={(e) => handlChangeColor(idx, e.target.name, e.target.value)}
                          className="h-[6vh] w-[7vw] p-2"
                          name="subtractStock"
                          id=""
                        >
                          <option selected>Select</option>
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                      </td>
                      <td>
                        <input
                          placeholder="Enter Price "
                          value={c.price}
                          onChange={(e) => {
                            const inputValue = e.target.value.trim();
                            if (
                              inputValue === "" ||
                              (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            ) {
                              handlChangeColor(idx, e.target.name, e.target.value);
                            }
                          }}
                          type="text"
                          name="price"
                          className="w-[10vw] p-2 h-[6vh]"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={c.sellingprice}
                          onChange={(e) => {
                            const inputValue = e.target.value.trim();
                            if (
                              inputValue === "" ||
                              (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            ) {
                              handlChangeColor(idx, e.target.name, e.target.value);
                            }
                          }}
                          name="sellingprice"
                          placeholder="Enter Selling Price"
                          className="w-[7vw] p-2 h-[6vh]"
                        />
                      </td>
                      <td>
                        <button
                          // disabled={colorOptions.length <= 1}
                          onClick={() => removeColorAttribute(idx)}
                          type="button"
                          className="border-none outline-none bg-transparent"
                        >
                          <IoIosRemoveCircleOutline className="text-xl cursor-pointer text-red-700" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        <div className="mt-4">
          {selectedOption === "att2" && (
            <table>
              <thead>
                <tr>
                  <th className="font-semibold text-md">Name</th>
                  <th>Parent</th>
                  <th>Choose Image</th>
                  <th>Quantity</th>
                  <th>Subtract Stock</th>
                  <th>Price</th>
                  <th>Selling Price</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {sizeOptions.map((size, idx) => {
                  return (
                    <tr key={idx}>
                      <td>
                        <input
                          name="value"
                          onChange={(e) => handleChangeSize(idx, e.target.name, e.target.value)}
                          type="text"
                          value={size.value}
                          placeholder="Enter Attribute Name"
                          className="p-2 pl-2 w-[15vw]"
                        />
                      </td>
                      <td>
                        <div className="flex flex-col gap-3">
                          <select
                            name="selectedValue"
                            value={size.selectedValue}
                            onChange={(e) => handleChangeSize(idx, e.target.name, e.target.value)}
                            className="w-[12vw] h-[6vh] p-2"
                          >
                            <option>Select</option>
                            {attributesValuesFromFirst.map((att, index) => {
                              return <option key={index}>{att}</option>;
                            })}
                          </select>
                        </div>
                      </td>
                      <td>
                        <div>
                          {/* <div className="flex flex-col ml-4  gap-3  items-center">
                            <label className="" htmlFor={`profile_pic_${idx}`}>
                              <img
                                className="rounded-md"
                                style={{
                                  width: "100px",
                                  height: "40px",
                                  objectFit: "contain",
                                  cursor: "pointer",
                                  borderRadius: "5px",
                                }}
                                src={size?.preview ? size?.preview : placeholder}
                                alt="temp_img"
                              />
                            </label>
                          </div> */}

                          <input
                            id={`profile_pic_${idx}`}
                            style={{ display: "none" }}
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleImageChangeSizes(idx, e)}
                          />
                        </div>
                      </td>
                      <td>
                        <input
                          placeholder="Enter Quantity"
                          value={size.quantity}
                          onChange={(e) => {
                            const inputValue = e.target.value.trim();
                            if (
                              inputValue === "" ||
                              (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            ) {
                              handleChangeSize(idx, e.target.name, e.target.value);
                            }
                          }}
                          type="text"
                          name="quantity"
                          className="w-[10vw] p-2 h-[6vh]"
                        />
                      </td>
                      <td>
                        <select
                          value={size.subtractStock}
                          onChange={(e) => handleChangeSize(idx, e.target.name, e.target.value)}
                          className="h-[6vh] w-[7vw] p-2"
                          name="subtractStock"
                          id=""
                        >
                          <option>Select</option>
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                      </td>
                      <td>
                        <input
                          placeholder="Enter Price "
                          value={size.price}
                          onChange={(e) => {
                            const inputValue = e.target.value.trim();
                            if (
                              inputValue === "" ||
                              (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            ) {
                              handleChangeSize(idx, e.target.name, e.target.value);
                            }
                          }}
                          type="text"
                          name="price"
                          className="w-[10vw] p-2 h-[6vh]"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={size.sellingprice}
                          onChange={(e) => {
                            const inputValue = e.target.value.trim();
                            if (
                              inputValue === "" ||
                              (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            ) {
                              handleChangeSize(idx, e.target.name, e.target.value);
                            }
                          }}
                          name="sellingprice"
                          placeholder="Enter Selling Price"
                          className="w-[7vw] p-2 h-[6vh]"
                        />
                      </td>
                      <td>
                        <button
                          // disabled={sizeOptions.length <= 1}
                          onClick={() => handleRemoveSizeAttribute(idx)}
                          type="button"
                          className="border-none outline-none bg-transparent"
                        >
                          <IoIosRemoveCircleOutline className="text-xl cursor-pointer text-red-700" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        <div className="mt-4">
          {selectedOption === "att3" && (
            <table>
              <thead>
                <tr>
                  <th className="font-semibold text-md">Name</th>
                  <th>Parent</th>
                  <th>Choose Image</th>
                  <th>Quantity</th>
                  <th>Subtract Stock</th>
                  <th>Price</th>
                  <th>Selling Price</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {atttribute3.map((att, idx) => {
                  return (
                    <tr key={idx}>
                      <td>
                        <input
                          name="value"
                          value={att.value}
                          onChange={(e) => handleChangeAtt3(idx, e.target.name, e.target.value)}
                          type="text"
                          placeholder="Enter Attribute Name"
                          className="p-2 pl-2 w-[15vw]"
                        />
                      </td>
                      <td>
                        <div className="flex flex-col gap-3">
                          <select
                            name="selectedValue"
                            value={att.selectedValue}
                            onChange={(e) => handleChangeAtt3(idx, e.target.name, e.target.value)}
                            className="w-[12vw] h-[6vh] p-2"
                          >
                            <option>Select</option>
                            {attribute3Values.map((att, index) => {
                              return <option key={index}>{att.value}</option>;
                            })}
                          </select>
                        </div>
                      </td>
                      <td>
                        <div>
                          <div className="flex flex-col ml-4  gap-3  items-center">
                            {/* <label className="" htmlFor={`profile_pic_${idx}`}>
                              <img
                                className="rounded-md"
                                style={{
                                  width: "100px",
                                  height: "40px",
                                  objectFit: "contain",
                                  cursor: "pointer",
                                  borderRadius: "5px",
                                }}
                                src={att?.preview ? att?.preview : placeholder}
                                alt="temp_img"
                              />
                            </label> */}
                          </div>

                          <input
                            id={`profile_pic_${idx}`}
                            style={{ display: "none" }}
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleImageChangeAtt3(idx, e)}
                          />
                        </div>
                      </td>
                      <td>
                        <input
                          placeholder="Enter Quantity"
                          value={att.quantity}
                          onChange={(e) => {
                            const inputValue = e.target.value.trim();
                            if (
                              inputValue === "" ||
                              (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            ) {
                              handleChangeAtt3(idx, e.target.name, e.target.value);
                            }
                          }}
                          type="text"
                          name="quantity"
                          className="w-[10vw] p-2 h-[6vh]"
                        />
                      </td>
                      <td>
                        <select
                          value={att.subtractStock}
                          onChange={(e) => handleChangeAtt3(idx, e.target.name, e.target.value)}
                          className="h-[6vh] w-[7vw] p-2"
                          name="subtractStock"
                          id=""
                        >
                          <option>Select</option>
                          <option>Yes</option>
                          <option>No</option>
                        </select>
                      </td>
                      <td>
                        <input
                          placeholder="Enter Price "
                          value={att.price}
                          onChange={(e) => {
                            const inputValue = e.target.value.trim();
                            if (
                              inputValue === "" ||
                              (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            ) {
                              handleChangeAtt3(idx, e.target.name, e.target.value);
                            }
                          }}
                          type="text"
                          name="price"
                          className="w-[10vw] p-2 h-[6vh]"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={att.sellingprice}
                          onChange={(e) => {
                            const inputValue = e.target.value.trim();
                            if (
                              inputValue === "" ||
                              (/^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) >= 0)
                            ) {
                              handleChangeAtt3(idx, e.target.name, e.target.value);
                            }
                          }}
                          name="sellingprice"
                          placeholder="Enter Selling Price"
                          className="w-[7vw] p-2 h-[6vh]"
                        />
                      </td>
                      <td>
                        <button
                          // disabled={atttribute3.length <= 1}
                          onClick={() => handleRemoveAtt3(idx)}
                          type="button"
                          className="border-none outline-none bg-transparent"
                        >
                          <IoIosRemoveCircleOutline className="text-xl cursor-pointer text-red-700" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
        {selectedOption === "att1" ? (
          <div className="flex justify-start ">
            <button
              type="button"
              className="bg-green-600 mt-4 text-white p-2 rounded-md border-none outline-none cursor-pointer"
              onClick={handleAddColorAttribute}
            >
              Add{" "}
            </button>
          </div>
        ) : selectedOption === "att2" ? (
          <div className="flex justify-start ">
            <button
              type="button"
              className="bg-green-600 mt-4 text-white p-2 rounded-md border-none outline-none cursor-pointer"
              onClick={handleAddSizeAttribute}
            >
              Add{" "}
            </button>
          </div>
        ) : selectedOption === "att3" ? (
          <div className="flex justify-start ">
            <button
              type="button"
              className="bg-green-600 mt-4 text-white p-2 rounded-md border-none outline-none cursor-pointer"
              onClick={handleAddAtt3}
            >
              Add{" "}
            </button>
          </div>
        ) : null}
      </div>
    </>
  );
}

// sizes form

function SizeForm({ data, setFunc }) {
  return (
    <>
      <div style={{ padding: "5px" }}>
        <div className="flex flex-col gap-4">
          <TextField
            value={data.size1}
            onChange={(e) => setFunc({ ...data, size1: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 1"
            variant="outlined"
          />
          <TextField
            value={data.size2}
            onChange={(e) => setFunc({ ...data, size2: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 2"
            variant="outlined"
          />
          <TextField
            value={data.size3}
            onChange={(e) => setFunc({ ...data, size3: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 3"
            variant="outlined"
          />
          <TextField
            value={data.size4}
            onChange={(e) => setFunc({ ...data, size4: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 4"
            variant="outlined"
          />
          <TextField
            value={data.size5}
            onChange={(e) => setFunc({ ...data, size5: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 5"
            variant="outlined"
          />
          <TextField
            value={data.size6}
            onChange={(e) => setFunc({ ...data, size6: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 6"
            variant="outlined"
          />
          <TextField
            value={data.size7}
            onChange={(e) => setFunc({ ...data, size8: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 7"
            variant="outlined"
          />
          <TextField
            value={data.size8}
            onChange={(e) => setFunc({ ...data, size8: e.target.value })}
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Size 8"
            variant="outlined"
          />
        </div>
      </div>
    </>
  );
}

// component to handle images of product form
function ImageForm({ categoryImages, setCategoryImages, categoryVid, setCategoryVid }) {
  // add more images-:

  const handleAddImages = () => {
    const newData = [...categoryImages];
    newData.push({
      image: "",
      preview: "",
    });
    setCategoryImages(newData);
  };

  const handleImageChange = (index, event) => {
    const updatedOptions = [...categoryImages];
    handleImagePreview(index, event);
    setCategoryImages(updatedOptions);
  };

  function handleImagePreview(index, event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        const updatedOptions = [...categoryImages];
        updatedOptions[index].image = file;
        updatedOptions[index].preview = reader.result;
        setCategoryImages(updatedOptions);
      };

      reader.readAsDataURL(file);
    }
  }

  const removeImageHandler = (idx) => {
    const newData = [...categoryImages];
    newData.splice(idx, 1);
    setCategoryImages(newData);
  };

  console.log(categoryImages);

  const handleVidChange = (event) => {
    const file = event.target.files[0];

    if (file && file.type.startsWith("video/")) {
      // Check if the selected file is a video
      setCategoryVid(URL.createObjectURL(file));
    } else {
      // Clear the selected video if the file is not a video
      setCategoryVid(null);
    }
  };

  return (
    <>
      <div style={{ padding: "5px" }}>
        <div className="flex flex-col">
          <span className="text-sm">Choose Video</span>
          <label htmlFor="cate_vid">
            <img
              className="rounded-md"
              style={{
                width: "100px",
                height: "40px",
                objectFit: "contain",
                cursor: "pointer",
                borderRadius: "5px",
              }}
              src={placeholder}
              alt="temp_img"
            />
            <input
              type="file"
              onChange={handleVidChange}
              id="cate_vid"
              accept="video/mp4,video/x-m4v,video/*"
              className="hidden"
            />
          </label>
          {categoryVid && (
            <div>
              <p className="text-sm">Video Preview:</p>
              <video width="320" height="240" controls>
                <source src={categoryVid} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          )}
        </div>
        <hr />
        <div className="flex flex-col mt-4 gap-4">
          <div className="flex flex-col gap-3">
            {categoryImages.map((c, idx) => {
              return (
                <div className="flex flex-col gap-2" key={idx}>
                  <span className="text-sm">Image Path</span>
                  <label htmlFor={`category_${idx}`}>
                    <img
                      className="rounded-md"
                      style={{
                        width: "100px",
                        height: "40px",
                        objectFit: "contain",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                      src={c?.preview ? c?.preview : placeholder}
                      alt="temp_img"
                    />
                    <input
                      type="file"
                      className="hidden"
                      id={`category_${idx}`}
                      onChange={(e) => handleImageChange(idx, e)}
                    />
                    <button
                      // disabled={colorOptions.length <= 1}
                      onClick={() => removeImageHandler(idx)}
                      type="button"
                      className="border-none outline-none bg-transparent"
                    >
                      <IoIosRemoveCircleOutline className="text-xl cursor-pointer text-red-700" />
                    </button>
                  </label>
                </div>
              );
            })}
          </div>
        </div>

        <div className="flex flex-col">
          <span className="text-sm">Image Descriptions</span>
          <label htmlFor="cate_vid">
            <img
              className="rounded-md"
              style={{
                width: "100px",
                height: "40px",
                objectFit: "contain",
                cursor: "pointer",
                borderRadius: "5px",
              }}
              src={placeholder}
              alt="temp_img"
            />
            <input
              type="file"
              onChange={handleVidChange}
              id="cate_vid"
              accept="video/mp4,video/x-m4v,video/*"
              className="hidden"
            />
          </label>
          <div>
            <Button
              cliclHandler={handleAddImages}
              type={"button"}
              title={"Add"}
              background={"blue"}
            />
          </div>
        </div>
      </div>
    </>
  );
}

function SeoForm({ data, setFunc }) {
  return (
    <>
      <div style={{ padding: "5px" }}>
        <div style={{ display: "flex", gap: "20px", flexDirection: "column" }}>
          <TextField
            id="outlined-basic"
            sx={{ width: "60vw" }}
            label="Keywords"
            variant="outlined"
          />
        </div>
      </div>
    </>
  );
}
